<template>
  <div class="c-monitor g-container">
    <moduler :ref="item.href" v-for="item in subModules" :name="item.href" :key="item.id" :title="item.name">
      <template v-if="item.href === 'rule'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">项目名称</span>
          </Col>
          <Col span="18">
            <input-len v-model="monitor.projectName" placeholder="最大60个字符，1个中文等于2个字符" :max="60" width="480" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field" style="line-height: 50px">账号配置</span>
          </Col>
          <Col span="21">
            <div v-for="(account, num) of monitor.accountConfig" :key="num" :style="{ marginBottom: '15px' }">
              <div class="budget-box box-top">
                <span class="box-feild">账号</span>
                <auto-complete
                  v-model="account.adAccountId"
                  :data="accounts"
                  :width="180"
                  placeholder="全部"
                  @on-select="handleAccount(num, $event)"
                />
                <div class="box-err-msg" v-if="formErr && isEmpty(account.adAccountId)"><span class="g-error-text">账号不能为空</span></div>
              </div>
              <div class="budget-box box-top">
                <span class="box-feild">在跑计划上限</span>
                <Select v-model="account.runPlanLimit" clearable placeholder="不限" style="width: 88px">
                  <Option v-for="(num, id) of limitCount" :key="id" :value="num">{{ num }}条</Option>
                </Select>
              </div>
              <div class="budget-box box-top" v-show="false">
                <span class="box-feild">在跑单素材上限</span>
                <Select v-model="account.runImageLimit" clearable placeholder="不限" style="width: 88px">
                  <Option v-for="(num, id) of limitCount" :key="id" :value="num">{{ num }}条</Option>
                </Select>
              </div>
              <div class="budget-box">
                <span class="box-feild">计划组预算</span>
                <RadioGroup v-model="account.budgetMode" vertical style="width: 140px">
                  <Radio label="NONE"><span>不限</span></Radio>
                  <Radio label="BUDGET">
                    <input-number-plus
                      v-model="account.dayBudget"
                      :max="7"
                      :min="300"
                      :precision="2"
                      :width="120"
                      :disabled="account.budgetMode === 'NONE'"
                      placeholder="请输入预算金额"
                    />
                  </Radio>
                </RadioGroup>
                <div class="box-err-msg" v-if="formErr && account.budgetMode === 'BUDGET' && isEmpty(account.dayBudget)">
                  <span class="g-error-text">计划组预算不能为空</span>
                </div>
              </div>
              <div class="budget-box" style="padding-right: 10px">
                <span class="box-feild">计划名称</span>
                <input-len
                  ref="planinput"
                  v-model="account.planNameTemplate"
                  placeholder="最多90个字符，1个中文等于2个字符"
                  width="316"
                  :max="90"
                  :dyn-pos="account.dynpos"
                  @on-del-trend="validTrend(num)"
                  @change="validTrend(num)"
                />
                <dd class="dynamic-error g-error-text" v-html="account.dynErr"></dd>
                <ul class="m-dynamic">
                  <span>插入动态词:</span>
                  <li v-for="(word, i) in dynwords" :key="i">
                    <a href="javascript:;" @click.stop="appendTrend(num, word)">+{{ word }}</a>
                  </li>
                </ul>
                <div class="box-err-msg" v-if="formErr && isEmpty(account.planNameTemplate)">
                  <span class="g-error-text">计划名称不能为空</span>
                </div>
              </div>
              <span class="m-rule-icon">
                <Icon v-if="accountLen > 1" type="ios-trash" size="25" color="#ff635c" @click.stop="handleConfig(num, 'del')" />
                <Icon
                  v-if="accountLen < 20 && !num"
                  type="ios-add-circle"
                  size="25"
                  color="#09CD8E"
                  @click.stop="handleConfig(num, 'add')"
                />
              </span>
            </div>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">计划数量</span>
          </Col>
          <Col span="12" :style="{ maxWidth: '525px' }">
            <div v-for="(rule, id) of monitor.adAddConfig" :key="id">
              <div class="plan-count m-rule">
                <span style="padding-right: 10px">每天</span>
                <Select v-model="rule.startRunHour" placeholder="请选择时间点" style="width: 140px">
                  <Option v-for="(time, id) in times" :key="id" :value="time">{{ time }}</Option>
                </Select>
                <span style="padding: 0 10px">开始创建</span>
                <div class="box-err-msg" v-if="formErr && isEmpty(rule.startRunHour)"><span class="g-error-text">时间点不能为空</span></div>
              </div>
              <div class="plan-count m-rule" style="margin-left: 10px">
                <span style="padding-right: 10px">每个账号创建</span>
                <input-number-plus v-model="rule.planCount" :max="3" :min="1" :precision="0" :width="60" placeholder="请输入" />
                <span style="padding: 0 10px">条计划</span>
                <span class="m-rule-icon">
                  <Icon v-if="addLen > 1" type="ios-trash" size="25" color="#ff635c" @click.stop="handleAdConfig(id, 'del')" />
                  <Icon v-if="addLen < 5 && !id" type="ios-add-circle" size="25" color="#09CD8E" @click.stop="handleAdConfig(id, 'add')" />
                </span>
                <div class="box-err-msg" v-if="formErr && (isEmpty(rule.planCount) || !rule.planCount)">
                  <span class="g-error-text">不能为空或者0</span>
                </div>
              </div>
            </div>
            <!-- <div class="plan-sp m-rule">
              <span>【计划分布】</span>
              <span>每个账号创建计划按照 </span>
              <span style="color:#ff0000"><ins>定向数</ins> * <ins>创意数</ins> * <ins>策略数</ins></span>
              <span>生成计划，然后随机分布在每个账号内，每个账号的计划都不一样</span>
            </div> -->
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">计划生成规则</span>
          </Col>
          <Col span="18">
            <RadioGroup v-model="monitor.adModel" type="button">
              <Radio :label="1">智能循环模式</Radio>
              <Radio :label="2">随机组合模式</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <!-- 自动同步 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">素材自动同步</span>
          </Col>
          <Col span="18">
            <div class="m-condition">
              <i-Switch v-model="monitor.imageAddEnable" :true-value="1" :false-value="0" />
              <span v-if="monitor.imageAddEnable" class="m-span-d">
                <span style="padding: 0 10px">每天自动同步的素材数不超过</span>
                <input-number-plus
                  v-model="monitor.imageAddCondition.dayLimit"
                  :max="3"
                  :min="1"
                  :precision="0"
                  :width="60"
                  placeholder="请输入"
                />
                <span style="padding: 0 10px">个，自动同步的总数不超过</span>
                <input-number-plus
                  v-model="monitor.imageAddCondition.totalLimit"
                  :max="3"
                  :min="1"
                  :precision="0"
                  :width="60"
                  placeholder="请输入"
                />
                <span style="padding: 0 10px">个</span>
              </span>
            </div>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="monitor.imageAddEnable">
          <Col span="3" class="col-item">
            <span class="item-field">数据统计周期</span>
          </Col>
          <Col span="18">
            <RadioGroup v-model="monitor.imageAddCondition.dateType" type="button">
              <Radio :label="1">今日实时</Radio>
              <Radio :label="2">近2天</Radio>
              <Radio :label="3">近3天</Radio>
              <Radio :label="5">近5天</Radio>
              <Radio :label="7">近7天</Radio>
            </RadioGroup>
            <span style="color: #ff0000; margin-left: 20px">全部含今天</span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="monitor.imageAddEnable">
          <Col span="3" class="col-item">
            <span class="item-field">触发条件</span>
          </Col>
          <Col span="12">
            <condition
              v-model="monitor.imageAddCondition.detail"
              :data="imageRuleData"
              :satisfy="monitor.imageAddCondition.monitorType"
              :max-cond="10"
              :verify="formErr"
              noinit
              @on-change="changeImageAddSatisfy"
            />
          </Col>
        </Row>
        <!-- 素材 end -->

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">定向自动同步</span>
          </Col>
          <Col span="18">
            <div class="m-condition">
              <i-Switch v-model="monitor.targetingAddEnable" :true-value="1" :false-value="0" />
              <span v-if="monitor.targetingAddEnable" class="m-span-d">
                <span style="padding: 0 10px">每天自动同步的定向数不超过</span>
                <input-number-plus
                  v-model="monitor.targetingAddCondition.dayLimit"
                  :max="3"
                  :min="1"
                  :precision="0"
                  :width="60"
                  placeholder="请输入"
                />
                <span style="padding: 0 10px">个，自动同步的总数不超过</span>
                <input-number-plus
                  v-model="monitor.targetingAddCondition.totalLimit"
                  :max="3"
                  :min="1"
                  :precision="0"
                  :width="60"
                  placeholder="请输入"
                />
                <span style="padding: 0 10px">个</span>
              </span>
            </div>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="monitor.targetingAddEnable">
          <Col span="3" class="col-item">
            <span class="item-field">数据统计周期</span>
          </Col>
          <Col span="18">
            <RadioGroup v-model="monitor.targetingAddCondition.dateType" type="button">
              <Radio :label="1">今日实时</Radio>
              <Radio :label="2">近2天</Radio>
              <Radio :label="3">近3天</Radio>
              <Radio :label="5">近5天</Radio>
              <Radio :label="7">近7天</Radio>
            </RadioGroup>
            <span style="color: #ff0000; margin-left: 20px">全部含今天</span>
            <div class="m-condition m-confition-warn">
              <span>当定向数据范围选择2日以上时，"首日ROI"触发条件才有效</span>
              <span>当定向数据范围选择5日以上时，"3ROI"触发条件才有效</span>
              <span>当定向数据范围选择7日以上时，"5ROI"触发条件才有效</span>
            </div>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="monitor.targetingAddEnable">
          <Col span="3" class="col-item">
            <span class="item-field">触发条件</span>
          </Col>
          <Col span="12">
            <condition
              v-model="monitor.targetingAddCondition.detail"
              :data="targetRuleData"
              :satisfy="monitor.targetingAddCondition.monitorType"
              :max-cond="10"
              :verify="formErr"
              noinit
              @on-change="changeTargetingAddSatisfy"
            />
          </Col>
        </Row>
        <!-- 定向 end -->

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">素材自动淘汰</span>
          </Col>
          <Col span="18">
            <div class="m-condition">
              <i-Switch v-model="monitor.imageDeleteEnable" :true-value="1" :false-value="0" />
            </div>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="monitor.imageDeleteEnable">
          <Col span="3" class="col-item">
            <span class="item-field">数据统计周期</span>
          </Col>
          <Col span="18">
            <RadioGroup v-model="monitor.imageDeleteCondition.dateType" type="button">
              <Radio :label="1">今日实时</Radio>
              <Radio :label="2">近2天</Radio>
              <Radio :label="3">近3天</Radio>
              <Radio :label="5">近5天</Radio>
              <Radio :label="7">近7天</Radio>
            </RadioGroup>
            <span style="color: #ff0000; margin-left: 20px">全部含今天</span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="monitor.imageDeleteEnable">
          <Col span="3" class="col-item">
            <span class="item-field">触发条件</span>
          </Col>
          <Col span="12">
            <condition
              v-model="monitor.imageDeleteCondition.detail"
              :data="imageRuleData"
              :satisfy="monitor.imageDeleteCondition.monitorType"
              :max-cond="10"
              :verify="formErr"
              noinit
              @on-change="changeImageDelSatisfy"
            />
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">定向自动淘汰</span>
          </Col>
          <Col span="18">
            <div class="m-condition">
              <i-Switch v-model="monitor.targetingDeleteEnable" :true-value="1" :false-value="0" />
            </div>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="monitor.targetingDeleteEnable">
          <Col span="3" class="col-item">
            <span class="item-field">数据统计周期</span>
          </Col>
          <Col span="18">
            <RadioGroup v-model="monitor.targetingDeleteCondition.dateType" type="button">
              <Radio :label="1">今日实时</Radio>
              <Radio :label="2">近2天</Radio>
              <Radio :label="3">近3天</Radio>
              <Radio :label="5">近5天</Radio>
              <Radio :label="7">近7天</Radio>
            </RadioGroup>
            <span style="color: #ff0000; margin-left: 20px">全部含今天</span>
            <div class="m-condition m-confition-warn">
              <span>当定向数据范围选择2日以上时，"首日ROI"触发条件才有效</span>
              <span>当定向数据范围选择5日以上时，"3ROI"触发条件才有效</span>
              <span>当定向数据范围选择7日以上时，"5ROI"触发条件才有效</span>
            </div>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="monitor.targetingDeleteEnable">
          <Col span="3" class="col-item">
            <span class="item-field">触发条件</span>
          </Col>
          <Col span="12">
            <condition
              v-model="monitor.targetingDeleteCondition.detail"
              :data="targetRuleData"
              :satisfy="monitor.targetingDeleteCondition.monitorType"
              :max-cond="10"
              :verify="formErr"
              noinit
              @on-change="changeTargetingDelSatisfy"
            />
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">智能自动化</span>
          </Col>
          <Col span="18">
            <select-monitor :data="monitorPlan" :media="media" :open-id="opId" @on-delete="delMonitor" @on-select="appendMonitor" />
          </Col>
        </Row>
      </template>
    </moduler>

    <!-- 下一步 -->
    <affix target="c-monitor" :offset-bottom="0">
      <div class="ad-submit">
        <Row class="ad-submit-moduler">
          <Col :span="12">
            <error-pop v-model="formErr" :data="errRes" :state="Boolean(errRes.length)" @close="errRes = []" />
          </Col>
          <Col :span="12" class="ad-submit-control">
            <template v-if="modifiesState">
              <Button @click="back">查看上一步</Button>
              <Button type="primary" :loading="loading" @click.stop="submit">
                <span v-if="!loading">保存提交</span>
                <span v-else>提交中...</span>
              </Button>
            </template>
            <template v-else>
              <Button @click="back">上一步</Button>
              <Button v-if="detState" type="primary" :loading="loading" @click.stop="submit">
                <span v-if="!loading">完成复制</span>
                <span v-else>提交中...</span>
              </Button>
              <Button v-else type="primary" :loading="loading" @click.stop="submitToNext">
                <span v-if="!loading">完成</span>
                <span v-else>提交中...</span>
              </Button>
            </template>
          </Col>
        </Row>
      </div>
    </affix>
  </div>
</template>
<script>
import mixin from './mixin'
import { getSession, setSession, clearSession } from '@/common/js/api'
import { timeout, isArray, isEmpty, deepCopy, pullKeys, getByteLen } from '@/common/js/utils'

import filterTargets from './components/data/filter_targets'
import filterImages from './components/data/filter_images'

import SelectMonitor from '@/components/select/select-monitor.vue'
import Condition from '@/components/condition/condition-plus'
import AutoComplete from '@/components/autocomplete/autocomplete'

import { addMonitorProject, getMonitorProject, editMonitorProject, getAutoRuleDetail } from '@/api/manage.model'
import { getSysTag, adAccount } from '@/api/common.model'

const dynwords = ['日期', '时间', '定向包名', '素材名称', '策略名称']
const times = [
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30'
]
const limitCount = [3, 5, 10, 15, 20, 25, 30, 35, 40, 50, 60, 70, 80, 90, 100, 120, 140, 160, 180, 200]
const initCondition = filterTargets[0]

export default {
  name: 'rebotMonitor',
  mixins: [mixin],
  components: { SelectMonitor, Condition, AutoComplete },
  computed: {
    editState() {
      return Boolean(this.$route.query) && this.$route.query.t === 'edit'
    },
    backState() {
      return Boolean(this.$route.query) && this.$route.query.g === 'back'
    },
    detState() {
      return Boolean(this.$route.query) && Boolean(this.$route.query.id)
    },
    modifiesState() {
      return this.editState && this.detState
    },
    addLen() {
      return this.monitor && this.monitor.adAddConfig ? this.monitor.adAddConfig.length : 0
    },
    accountLen() {
      return this.monitor && this.monitor.accountConfig ? this.monitor.accountConfig.length : 0
    }
  },
  methods: {
    isEmpty,
    getData() {
      const max_proId = 1551
      const { id } = this.$route.query

      if (id < max_proId) {
        this.$Message.error({
          content: '老的项目暂不支持更改，请关闭重新新建！',
          duration: 5
        })
        return
      }
      this.$Spin.show()
      getMonitorProject({ projectId: id }).then((data) => {
        this.$Spin.hide()
        if (data) {
          let assastAcountConfig
          const {
            projectId,
            projectName,
            autoRuleIds,
            adAddConfig,
            accountConfig,
            adModel,
            imageAddEnable,
            imageDeleteEnable,
            targetingAddEnable,
            targetingDeleteEnable,
            imageAddCondition,
            imageDeleteCondition,
            targetingAddCondition,
            targetingDeleteCondition
          } = data
          const defaultPlusCondition = {
            dateType: 1,
            dayLimit: '',
            totalLimit: '',
            monitorType: 'anyone',
            detail: [deepCopy(initCondition)]
          }
          const defaultCondition = {
            dateType: 1,
            monitorType: 'anyone',
            detail: [deepCopy(initCondition)]
          }

          this.reverMonitorPlan(autoRuleIds)
          if (isArray(accountConfig)) {
            assastAcountConfig = accountConfig.map((ret, id) => {
              if (ret.dayBudget === 0) {
                ret.budgetMode = 'NONE'
                ret.dayBudget = ''
              }
              ret.runPlanLimit = ret.runPlanLimit === 0 ? '' : ret.runPlanLimit
              ret.runImageLimit = ret.runImageLimit === 0 ? '' : ret.runImageLimit
              this.validTrend(id)
              return ret
            }) // 动态词
          }
          this.monitor = {
            projectId,
            projectName: this.detState && !this.modifiesState ? `${projectName}_复制` : projectName,
            adAddConfig,
            accountConfig: assastAcountConfig,
            adModel,
            imageAddEnable,
            imageDeleteEnable,
            targetingAddEnable,
            targetingDeleteEnable,
            imageAddCondition: imageAddCondition || deepCopy(defaultPlusCondition),
            imageDeleteCondition: imageDeleteCondition || deepCopy(defaultPlusCondition),
            targetingAddCondition: targetingAddCondition || deepCopy(defaultCondition),
            targetingDeleteCondition: targetingDeleteCondition || deepCopy(defaultCondition)
          }
          if (data.frontSubmit) {
            const { documents, materies, materiesImage, policies, targets } = data.frontSubmit
            data.documentIdList = documents.map((ret) => ret.docId)
            data.imageDetailIdList = data.imageDetailIds ? data.imageDetailIds.split(',').map((ret) => Number(ret)) : []
            data.strategyIdList = policies.map((ret) => ret.id)
            data.targetingIdList = targets.map((ret) => ret.targetingId)
            data = Object.assign({}, data, { documents, materies, materiesImage, policies, targets })
          }
          this.projectParams = data
        }
      })
    },
    reverMonitorPlan(ids) {
      const query = ids.map((ret) => {
        return getAutoRuleDetail({ ruleId: ret })
      })
      Promise.all(query).then((data) => {
        if (isArray(data)) {
          this.monitorPlan = data
        }
      })
    },
    // 添加动态词
    appendTrend(id, word) {
      const param = this.monitor.accountConfig[id]
      if (!param) return
      const title = deepCopy(param.planNameTemplate)
      const { selectionStart } = this.$refs.planinput[id].$refs.input.$refs.input
      const prefix = title.substring(0, selectionStart)
      const suffix = title.substring(selectionStart)
      if (title.indexOf(word) > -1) {
        this.$Message.error('不能使用重复的动态词')
        return
      }
      this.$set(param, 'planNameTemplate', `${prefix}{${word}}${suffix}`)
      this.validTrend(id)
      this.$refs.planinput[id].focus()
    },
    // 动态词验证
    validTrend(id) {
      const param = this.monitor.accountConfig[id]
      if (!param) return
      const plan_name = deepCopy(param.planNameTemplate)
      if (isEmpty(plan_name)) return
      let dynErr = ''
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = plan_name.match(regexp)
      const count = (str, cut) => {
        if (typeof str !== 'string') return 0
        return str.split('').filter((ret) => ret === cut).length
      }
      if (count(plan_name, '{') !== count(plan_name, '}')) {
        dynErr = '动态词包格式错误'
      } else if (plan_name.replace(regexp, '').includes('{') || plan_name.replace(regexp, '').includes('{')) {
        dynErr = '动态词包标识{}不允许作为内容出现'
      } else if (isArray(values) && values.some((ret) => !this.dynwords.map((met) => `{${met}}`).includes(ret))) {
        dynErr = '动态词包不存在'
      } else if (isArray(values) && values.some((ret, i) => values.indexOf(ret) !== i)) {
        dynErr = '动态词包不能存在相同'
      }
      // 动态词位置
      let dynPos = []
      if (isArray(values)) {
        dynPos = values
          .filter((ret) => this.dynwords.map((met) => `{${met}}`).includes(ret))
          .map((m) => {
            const min = plan_name.indexOf(m)
            return [min, min + m.length]
          })
      }
      this.$set(param, 'dynpos', dynPos)
      this.$set(param, 'dynErr', dynErr)
    },
    preloadData() {
      const param = { mediaId: 10, authFlag: 1 }
      Promise.all([getSysTag(), adAccount(param)])
        .then((data) => {
          const [systags, accounts] = data
          isArray(accounts) && (this.accounts = accounts)
          if (isArray(systags)) {
            const index = this.imageRuleData.findIndex((ret) => ret.id === 16)
            const tags = systags.map((ret) => {
              return { value: ret.labelId, label: ret.content }
            })
            if (index > -1) this.$set(this.imageRuleData[index], 'enum_property', tags)
          }
          if (this.backState) {
            const monitorParams = getSession('monitor_params') || {}
            this.monitor = Object.assign({}, this.monitor, monitorParams)
            this.monitorPlan = deepCopy(monitorParams.monitorPlan)
          } else if (this.detState) this.getData()
        })
        .catch((err) => {
          this.$Message.error(err)
          throw new Error(err)
        })
    },
    handleAccount(id, meta) {
      console.log(meta, id)
      if (!this.monitor.accountConfig[id] || !meta) return
      this.$set(this.monitor.accountConfig[id], 'adAccountId', meta.id)
    },
    handleConfig(id, type) {
      if (type === 'add') {
        this.monitor.accountConfig.push({
          budgetMode: 'NONE',
          adAccountId: '',
          planNameTemplate: '',
          dayBudget: '',
          runPlanLimit: '',
          runImageLimit: '',
          dynErr: '',
          dynpos: []
        })
      } else if (type === 'del') this.monitor.accountConfig.splice(id, 1)
    },
    handleAdConfig(id, type) {
      if (type === 'add') {
        this.monitor.adAddConfig.push({
          startRunHour: '',
          planCount: ''
        })
      } else if (type === 'del') this.monitor.adAddConfig.splice(id, 1)
    },
    // 删除自动化规则
    delMonitor(id) {
      const index = this.monitorPlan.findIndex((ret) => ret.id === id)
      if (index > -1) this.monitorPlan.splice(index, 1)
    },
    // 添加自动化规则回调
    appendMonitor(val) {
      this.monitorPlan = val
    },
    // 改变监控规则
    changeImageAddSatisfy(val) {
      this.$set(this.monitor.imageAddCondition, 'monitorType', val)
    },
    changeTargetingAddSatisfy(val) {
      this.$set(this.monitor.targetingAddCondition, 'monitorType', val)
    },
    changeImageDelSatisfy(val) {
      this.$set(this.monitor.imageDeleteCondition, 'monitorType', val)
    },
    changeTargetingDelSatisfy(val) {
      this.$set(this.monitor.targetingDeleteCondition, 'monitorType', val)
    },
    back() {
      const route = this.detState
        ? this.modifiesState
          ? { name: 'robotproject', query: { id: this.monitor.projectId, t: 'edit', g: 'back' } }
          : { name: 'robotproject', query: { id: this.monitor.projectId, g: 'back' } }
        : { name: 'robotproject', query: { g: 'back' } }
      this.$Modal.confirm({
        title: '提示',
        content: '<p>当前编辑数据未保存，返回将丢失编辑数据。</p><p>是否保存当前数据</p>',
        loading: true,
        okText: '是',
        cancelText: '否',
        onOk: () => {
          this.monitor.monitorPlan = this.monitorPlan
          setSession('monitor_params', this.monitor)
          timeout(800).then(() => {
            this.$Modal.remove()
            this.$router.push(route)
          })
        },
        onCancel: () => {
          setSession('monitor_params', { projectId: this.monitor.projectId })
          this.$router.push(route)
        }
      })
    },
    len(planName) {
      let strLen
      const charLen = 2
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const data = String(planName)
      const values = data.match(regexp)
      strLen = getByteLen(data, charLen)
      // dynct
      if (isArray(values) && values.length) {
        values.forEach((ret) => {
          ret === '{定向包名}' && (strLen += 11)
          ret === '{创意组名}' && (strLen += 11)
          ret === '{策略名称}' && (strLen += 11)
          ret === '{素材名称}' && (strLen += 9)
        })
      }
      return strLen
    },
    customValid(params) {
      const err = []
      const configAccountId = params.accountConfig.some((ret) => isEmpty(ret.adAccountId))
      configAccountId && err.push({ feild: '账号配置', msg: '账号不能为空' })
      const configAccountIdSame = params.accountConfig.some(
        (ret, id) => id !== params.accountConfig.findIndex((met) => met.adAccountId === ret.adAccountId)
      )
      configAccountIdSame && err.push({ feild: '账号配置', msg: '账号不能相同' })
      const configNameTemplate = params.accountConfig.some((ret) => isEmpty(ret.planNameTemplate) || this.len(ret.planNameTemplate) > 90)
      configNameTemplate && err.push({ feild: '账号配置', msg: '账号计划名称不能为空，最多90个字符' })
      const configDayBudget = params.accountConfig.some((ret) => isEmpty(ret.dayBudget) && ret.budgetMode === 'BUDGET')
      configDayBudget && err.push({ feild: '账号配置', msg: '计划组预算不能为空' })
      const configNameTemplateDynErr = params.accountConfig.some((ret) => !isEmpty(ret.dynErr))
      configNameTemplateDynErr && err.push({ feild: '账号配置', msg: '账号计划名称验证不通过' })

      const adAddRunHour = params.adAddConfig.some((ret) => isEmpty(ret.startRunHour))
      adAddRunHour && err.push({ feild: '计划数量', msg: '创建计划时间不能为空' })
      const adAddPlanCount = params.adAddConfig.some((ret) => isEmpty(ret.planCount))
      adAddPlanCount && err.push({ feild: '计划数量', msg: '创建计划数不能为空' })
      const adAddRunHourSame = params.adAddConfig.some(
        (ret, id) => id !== params.adAddConfig.findIndex((met) => met.startRunHour === ret.startRunHour)
      )
      adAddRunHourSame && err.push({ feild: '计划数量', msg: '创建计划时间不能相同' })

      // 触发条件
      const condiImageAddValid = params.imageAddCondition.detail.some((ret) => isEmpty(ret.value))
      if (params.imageAddEnable && condiImageAddValid) {
        err.push({ feild: '素材自动同步', msg: '触发条件中的值验证不通过' })
      }
      const condiTargetAddValid = params.targetingAddCondition.detail.some((ret) => isEmpty(ret.value))
      if (params.targetingAddEnable && condiTargetAddValid) {
        err.push({ feild: '定向自动同步', msg: '触发条件中的值验证不通过' })
      }
      const condiImageDelValid = params.imageDeleteCondition.detail.some((ret) => isEmpty(ret.value))
      if (params.imageDeleteEnable && condiImageDelValid) {
        err.push({ feild: '素材自动淘汰', msg: '触发条件中的值验证不通过' })
      }
      const condiTargetDelValid = params.targetingDeleteCondition.detail.some((ret) => isEmpty(ret.value))
      if (params.targetingDeleteEnable && condiTargetDelValid) {
        err.push({ feild: '定向自动淘汰', msg: '触发条件中的值验证不通过' })
      }
      return err
    },
    valid() {
      const rules = [
        {
          name: 'monitor/projectName',
          require: true,
          min: 3,
          max: 60,
          desc: '项目名称'
        },
        {
          name: 'monitor/accountConfig',
          require: true,
          min: 1,
          desc: '账号配置'
        },
        {
          name: 'monitor/adAddConfig',
          require: true,
          min: 1,
          desc: '计划数量'
        },
        {
          name: 'monitor/imageAddCondition/dayLimit',
          require: true,
          relyon: 'monitor/imageAddEnable',
          relyvalue: 1,
          min: 1,
          desc: '媒体自动同步每天限制总数'
        },
        {
          name: 'monitor/imageAddCondition/totalLimit',
          require: true,
          relyon: 'monitor/imageAddEnable',
          relyvalue: 1,
          min: 1,
          desc: '媒体自动同步总限制数'
        },
        {
          name: 'monitor/targetingAddCondition/dayLimit',
          require: true,
          relyon: 'monitor/targetingAddEnable',
          relyvalue: 1,
          min: 1,
          desc: '定向自动同步每天限制总数'
        },
        {
          name: 'monitor/targetingAddCondition/totalLimit',
          require: true,
          relyon: 'monitor/targetingAddEnable',
          relyvalue: 1,
          min: 1,
          desc: '定向自动同步总限制数'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    submit() {
      const projectParams = getSession('project_params') || this.projectParams
      let params = deepCopy(this.monitor)
      this.formErr = false
      this.errRes = [...this.valid(), ...this.customValid(params)] // 表单验证
      if (this.errRes.length) {
        this.formErr = true
        return // 如果错误中断
      }

      params = Object.assign({}, deepCopy(projectParams), params)
      const basekeys = this.modifiesState
        ? [
          'projectName',
          'autoRuleIdList',
          'targetingIdList',
          'imageDetailIdList',
          'strategyIdList',
          'documentIdList',
          'adAddConfig',
          'accountConfig',
          'adModel'
        ]
        : [
          'projectName',
          'launchType',
          'gameId',
          'autoRuleIdList',
          'maxImageCount',
          'maxDocumentCount',
          'targetingIdList',
          'imageDetailIdList',
          'strategyIdList',
          'documentIdList',
          'adAddConfig',
          'accountConfig',
          'adModel'
        ]
      const baseInfo = pullKeys(basekeys, params)
      const synInfo = pullKeys(
        [
          'imageAddEnable',
          'imageDeleteEnable',
          'targetingAddEnable',
          'targetingDeleteEnable',
          'imageAddCondition',
          'imageDeleteCondition',
          'targetingAddCondition',
          'targetingDeleteCondition'
        ],
        params
      )
      const frontSubmit = pullKeys(['targets', 'materies', 'materiesImage', 'documents', 'policies'], params)
      if (!synInfo.imageAddEnable) synInfo.imageAddCondition = null
      if (!synInfo.imageDeleteEnable) synInfo.imageDeleteCondition = null
      if (!synInfo.targetingAddEnable) synInfo.targetingAddCondition = null
      if (!synInfo.targetingDeleteEnable) synInfo.targetingDeleteCondition = null
      if (isArray(baseInfo.accountConfig)) {
        baseInfo.accountConfig = baseInfo.accountConfig.map((ret) => {
          if (ret.budgetMode === 'NONE') ret.dayBudget = 0
          if (isEmpty(ret.runPlanLimit)) ret.runPlanLimit = 0
          if (isEmpty(ret.runImageLimit)) ret.runImageLimit = 0
          return ret
        })
      }

      const callFn = (data) => {
        this.loading = false
        if (data) {
          clearSession()
          this.$Message.info({
            content: '提交成功！页面将 2 秒后自动关闭',
            duration: 2,
            onClose: () => {
              window.close()
            }
          })
        }
      }
      this.loading = true
      if (this.modifiesState) editMonitorProject({ projectId: params.projectId, baseInfo, synInfo, frontSubmit }).then(callFn)
      else addMonitorProject({ baseInfo, synInfo, frontSubmit }).then(callFn)
    },
    submitToNext() {
      const projectParams = getSession('project_params') || {}
      const monitorParams = deepCopy(this.monitor)
      this.formErr = false
      this.errRes = [...this.valid(), ...this.customValid(monitorParams)] // 表单验证
      if (this.errRes.length) {
        this.formErr = true
        return // 如果错误中断
      }

      const params = Object.assign({}, deepCopy(projectParams), monitorParams)
      const baseInfo = pullKeys(
        [
          'projectName',
          'launchType',
          'gameId',
          'autoRuleIdList',
          'maxImageCount',
          'maxDocumentCount',
          'targetingIdList',
          'imageDetailIdList',
          'strategyIdList',
          'documentIdList',
          'adAddConfig',
          'accountConfig',
          'adModel'
        ],
        params
      )
      const synInfo = pullKeys(
        [
          'imageAddEnable',
          'imageDeleteEnable',
          'targetingAddEnable',
          'targetingDeleteEnable',
          'imageAddCondition',
          'imageDeleteCondition',
          'targetingAddCondition',
          'targetingDeleteCondition'
        ],
        params
      )
      const frontSubmit = pullKeys(['targets', 'materies', 'materiesImage', 'documents', 'policies'], params)
      if (!synInfo.imageAddEnable) delete synInfo.imageAddCondition
      if (!synInfo.imageDeleteEnable) delete synInfo.imageDeleteCondition
      if (!synInfo.targetingAddEnable) delete synInfo.targetingAddCondition
      if (!synInfo.targetingDeleteEnable) delete synInfo.targetingDeleteCondition
      if (isArray(baseInfo.accountConfig)) {
        baseInfo.accountConfig = baseInfo.accountConfig.map((ret) => {
          if (ret.budgetMode === 'NONE') ret.dayBudget = 0
          if (isEmpty(ret.runPlanLimit)) ret.runPlanLimit = 0
          if (isEmpty(ret.runImageLimit)) ret.runImageLimit = 0
          return ret
        })
      }

      this.loading = true
      addMonitorProject({ baseInfo, synInfo, frontSubmit }).then((data) => {
        this.loading = false
        if (data) {
          clearSession()
          this.$Message.info({
            content: '提交成功！页面将 2 秒后自动关闭',
            duration: 2,
            onClose: () => {
              window.close()
            }
          })
        }
      })
    }
  },
  data() {
    return {
      projectParams: {},
      monitor: {
        projectName: '',
        accountConfig: [
          {
            budgetMode: 'NONE',
            adAccountId: '',
            planNameTemplate: '',
            dayBudget: '',
            runPlanLimit: '',
            runImageLimit: '',
            dynErr: '',
            dynpos: [] // 动态词位置
          }
        ],
        adAddConfig: [
          {
            startRunHour: '',
            planCount: ''
          }
        ],
        adModel: 1,
        imageAddEnable: 0,
        targetingAddEnable: 0,
        imageDeleteEnable: 0,
        targetingDeleteEnable: 0,
        imageAddCondition: {
          dateType: 1,
          dayLimit: '',
          totalLimit: '',
          monitorType: 'anyone',
          detail: [deepCopy(initCondition)]
        },
        targetingAddCondition: {
          dateType: 1,
          dayLimit: '',
          totalLimit: '',
          monitorType: 'anyone',
          detail: [deepCopy(initCondition)]
        },
        imageDeleteCondition: {
          dateType: 1,
          monitorType: 'anyone',
          detail: [deepCopy(initCondition)]
        },
        targetingDeleteCondition: {
          dateType: 1,
          monitorType: 'anyone',
          detail: [deepCopy(initCondition)]
        }
      },
      monitorPlan: [], // 智能自动化
      imageRuleData: filterImages,
      targetRuleData: filterTargets,
      times: times,
      dynwords: [], // 动态词
      accounts: [], // 账号列表
      limitCount
    }
  },
  watch: {
    monitorPlan(nVal) {
      this.monitor.autoRuleIdList = nVal.map((ret) => ret.id)
    }
  },
  created() {
    this.dynwords = dynwords
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-monitor {
  position: relative;
  padding-bottom: 68px;

  .budget-box {
    display: inline-block;
    vertical-align: middle;
    padding-right: 22px;

    .box-feild {
      padding-right: 10px;
    }

    .ivu-radio-wrapper {
      text-align: left;
    }

    ins {
      color: green;
    }
  }

  .box-top {
    margin-bottom: 12px;
  }

  .dynamic-error {
    margin: 0;
  }

  .m-dynamic {
    padding-top: 10px;
    margin: 0;

    li {
      display: inline-block;
      margin-left: 12px;
    }
  }

  .plan-sp {
    line-height: 35px;

    ins {
      font-style: italic;
      padding: 0 8px;
    }
  }

  .m-rule {
    display: inline-block;
    margin-bottom: 12px;

    .m-rule-icon .ivu-icon {
      cursor: pointer;
    }
  }

  .m-condition {
    line-height: 32px;

    .m-span-d {
      display: inline-block;
      vertical-align: middle;
      margin-left: 10px;
    }
  }

  .m-confition-warn {
    color: #ff4400;
    padding: 6px 0;

    span {
      display: block;
      line-height: 22px;
    }
  }

  .ad-group,
  .ad-submit {
    padding: 15px 0 0 0;

    .ad-group-moduler,
    .ad-submit-moduler {
      padding: 16px 24px;
      background-color: #fff;
      border: 1px solid #eaeaea;
      border-radius: 2px;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.05);
    }
  }

  .ad-submit {
    padding-bottom: 0;

    .ad-submit-moduler {
      display: flex;
      justify-content: flex-end;
    }

    .ad-submit-control {
      text-align: right;

      button {
        margin-left: 6px !important;
      }
    }
  }
}

.row-item {
  align-items: flex-start;

  span.item-field {
    height: 32px;
    line-height: 32px;
  }
}
</style>
